import React, { useContext, useEffect, useState } from 'react'
import { View, StyleSheet, ScrollView, TouchableOpacity, Linking } from 'react-native'
import { Text, useTheme } from '@ui-kitten/components'
import { UserContext } from '../../global/UserProvider'
import HeaderIconButton from '../../components/HeaderIconButton'
import { organizationAtom, userRoleAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'

export default function LegalScreen({ navigation }) {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  // The marketing site (atlas-app.org) serves locale-prefixed routes (/en, /ru);
  // it supports the same two locales as the app. Legal docs live under /offer
  // (public offer = terms of use) and /privacy.
  const siteLocale = i18n.language === 'ru' ? 'ru' : 'en'
  const [context, setContext] = useContext(UserContext)
  const organization = useAtomValue(organizationAtom)
  const userRole = useAtomValue(userRoleAtom)

  useEffect(() => {
    if (navigation.getState()?.index === 0) {
      navigation.setOptions({
        headerLeft: () => (
          <HeaderIconButton
            onPress={() => {
              navigation.navigate('Home')
            }}
            iconName='arrow-back-outline'
          />
        ),
      })
    }
  }, [])

 

  const menuItems = [
    {
      title: t('helpCenter.termsOfUse'),
      onPress: () => Linking.openURL(`https://atlas-app.org/${siteLocale}/offer`),
    },
    {
      title: t('helpCenter.privacyPolicy'),
      onPress: () => Linking.openURL(`https://atlas-app.org/${siteLocale}/privacy`),
    },
    {
      title: t('helpCenter.eula'),
      onPress: () => Linking.openURL('https://www.apple.com/legal/internet-services/itunes/dev/stdeula/'),
    },
  ]

  return (
    <ScrollView style={styles.container}>
        {
          menuItems.map((item, index) => (
            ((userRole?.permissions?.[item.permission] || context.user?.role === 'admin' || !item.permission) && 
            (item.organizationIds == null || item.organizationIds.includes(context.user?.organizationId))) && 
            (item.module == null || organization?.moduleEnabled?.[item.module]) &&
            (
              <TouchableOpacity
                style={[styles.item, {backgroundColor: theme['background-basic-color-1']}]}
                onPress={item.onPress}
                key={index.toString()}
              >
                <Text
                  style={styles.itemTitle}
                  category='s2'>
                  {item.title}
                </Text>
              </TouchableOpacity>
            )
          ))
        }
        <View style={{height:50}}></View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
  },
  item: {
    borderRadius: 10,
    padding: 10,
    marginVertical: 5
  }, 

});
